(function () {
  'use strict';
  angular.module('vcconsult')
    .component('consultrecord', {
      restrict: 'E',
      bindings: {
        patientid: '<'
      },
      template: `
      <div class="consultrecord-component" data-hook="consultrecord-component">
        <consultnew ng-if="vm.show === 'new' || vm.consult.open === false"
                    patientid="vm.patientid" oncreate="vm.oncreate(consult)"></consultnew>
        <carteditorstandalone ng-if="vm.show === 'new' || vm.consult.open === false"
                    clientid="vm.patientid"></carteditorstandalone>
        <consulteditor ng-if="vm.show === 'consult'"
                       consultid="vm.consultid" startcheckout="vm.startcheckout()"
                       onfinish="vm.onfinish(consultid)"></consulteditor>
        <!--<consultfinish ng-show="vm.show === 'consult' && vm.consult.open === false" consultid="vm.consultid" onfinish="vm.onfinish(consult)"></div>-->
        <div ng-show="vm.show === 'error'">
          <div class="alert alert-danger">
              <h3>Mehrere offene Konsultationen für diesen Patienten gefunden!</h3>
              <p>Wählen Sie eine Konsultation aus um mit dieser fortzufahren. Alle anderen Konsultationen werden geschlossen.</p>
          </div>
          <div ng-repeat="cons in vm.openconsults">
            <span class="pull-left">Konsultation vom {{cons.fdate}}</span>
            <span class="pull-right"><span class="btn btn-success" ng-click="vm.keepconsult($index)">Konsultation weiterführen</span> </span>
            <span class="clearfix"></span>
          </div>
            <div class="spacer-top"><span class="btn btn-warning" ng-click="vm.keepconsult(-1)">Alle Konsultationen schließen</span> </div>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Consult', 'Rlog', 'vertxEventBusService', '$window',
        function ($log, Consult, Rlog, vertxEventBusService, $window) {
          let vm = this;
          vm.startcheckout = startcheckout;
          vm.onfinish = onfinish;
          vm.oncreate = oncreate;
          vm.keepconsult = keepconsult;

/*
          vm.$onInit = function () {
            $log.debug('consultrecord on Init patid: ', vm.patientid);
            getConsult();
          };*/

          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue) &&  changes.patientid.currentValue.length > 0) {
              vm.patientid = changes.patientid.currentValue;
              getConsult();
            }
          }; // $onInit


          function startcheckout() {
            vm.show = 'finish';
          }

          function getConsult() {
            Consult.$search({patientid: vm.patientid, active: true, open: true}).$then(function (consults) {
              $log.debug('consultrecord number of active open consults: ', consults.length);
              switch (consults.length) {
                case 0:
                  vm.show = 'new';
                  delete vm.consult;
                  break;
                case 1:
                  vm.show = 'consult';
                  vm.consult = consults[0];
                  vm.consultid = consults[0]._id;
                  break;
                default:
                  vm.show = 'error';
                  vm.openconsults = consults;
                  break;
              }
            }, function (err) {
              $log.error('consult not found, id: ', vm.consultid, err);
              Rlog.error('consult', 'consulteditor', 'consult not found', {_id: vm.consultid});
            });
          }

          function keepconsult(index) {
            for (let i = 0; i < vm.openconsults.length; i++) {
              vm.show = 'new';
              if (i !== index) {
                vm.openconsults[i].open = false;
                vm.openconsults[i].$save();
              } else {
                vm.consult = vm.openconsults[index];
                vm.show = 'consult';
              }
            }

          }

          function onfinish(consultid) {
            $log.debug(' ### consultrecord on finish called consultid: ', consultid);
            vm.show = 'new';
          }

          function oncreate(consult) {
            vm.consult = consult;
            vm.consultid = consult._id;
            $log.debug(' ### consultrecord on create vm.consult: ', vm.consult);
            vm.show = 'consult';
          }


          vertxEventBusService.on('consults.close', function (message) {
            $log.debug(' ### consultrecord  Consults close received: ', message);
            let messages = message.data.split(':');
            if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.consult._id === messages[0]) {
              $log.debug(' ### consultrecord received consult close from other tab/client for: ', messages[0]);
              vm.show = 'new';
            }
          });

          vertxEventBusService.on('consults.create', function (message) {
            $log.debug(' ### consultrecord  Consults create received: ', message);
            let messages = message.split(':');
            if (messages[1] !== $window.sessionStorage.getItem('sprtabid')) {
              $log.debug(' ### consultrecord received consult create from other tab/client for: ', messages[0]);
              if (vm.show !== 'consult') {
                getConsult(vm.patientid);
              }
            }
          });
        }] // controller
    }); // component

// klammerfriedhof
}());
